import request from '@/service/request'

export const getCustomerPage = (params: {pageNum: number, pageSize: number, nickname: string}) => {
  return request<SERVICE.ResponsePage<HOME.CUSTOMER[]>>({
    url: '/admin/wx-mp-user/page',
    method: 'GET',
    params
  })
}

export const exportExcel = () => {
  return request<Boolean>({
    url: '/admin/wx-mp-user/export',
    method: 'GET'
  })
}
